import React, { useContext } from 'react';
import { Button, DeleteInvoice, FieldBold, InvoiceDetail, Tags } from '../../../../components';
import utils from '../../../../services/utils';
import { ReactComponent as Trash } from '../../../../assets/icons/Trash.svg';

import classes from './ResumeInvoiceCard.module.scss';
import Context from '../../../../store/context';

import { useNavigate } from 'react-router-dom';
import { paths } from '../../../../routes';

const ResumeInvoiceCard = ({ invoiceIdx, supplierIdx, invoice, setSuppliersGrouping, invoicesSelected, costTransaction, methodForPay }) => {
  const navigate = useNavigate();
  const {
    modal: { showModal, hideModal }
  } = useContext(Context);

  const deleteClick = (idx, lastInvoice) => {
    setSuppliersGrouping(suppliers => {
      const auxSuppliers = [...suppliers.suppliersInvoices];
      auxSuppliers[supplierIdx] = {
        ...auxSuppliers[supplierIdx],
        invoices: auxSuppliers[supplierIdx].invoices.filter((invoice, index) => invoiceIdx !== index)
      };
      if (auxSuppliers[supplierIdx].invoices.length === 0) {
        auxSuppliers.splice(supplierIdx, 1);
      }
      return { ...suppliers, suppliersInvoices: auxSuppliers };
    });
    if (lastInvoice) {
      navigate(paths.invoices);
    }
    hideModal();
  };
  const { valueSelectionType, pendingValue, partValue, issueDate, description } = invoice;

  const invoiceDescription =
    invoice?.description ||
    invoice?.descriptionItems ||
    invoice?.items?.[0]?.description ||
    invoice?.items?.[0]?.nameProduct ||
    'N/A';

  const showInvoiceDetail = () => {
    showModal(<InvoiceDetail invoice={invoice} supplier={invoice.supplier} />);
  };

  const deleteInvoice = () => {
    showModal(
      <DeleteInvoice
        deleteClick={deleteClick}
        invoiceIdx={invoiceIdx}
        pendingValue={pendingValue}
        date={issueDate}
        invoicesSelected={invoicesSelected}
        description={invoiceDescription}
      />,
      false
    );
  };

  return (
    <div className={classes.card}>
      <div className={classes.head}>
        <span {...(invoiceDescription && { title: invoiceDescription })} className={` text-ellipsis medium-16`}>
          {invoiceDescription}
        </span>
        <Tags
          type={valueSelectionType === 'all' ? 'green' : 'gray'}
          text={valueSelectionType === 'all' ? 'Pago total' : 'Pago parcial'}
        />
      </div>
      <FieldBold title='TOTAL A PAGAR' value={utils.moneyFormat((valueSelectionType === 'all' ? pendingValue : partValue))} />
      <div className={classes.footer}>
        <Button custom='quaternary' onClick={showInvoiceDetail}>
          Ver detalles
        </Button>
        <Button custom='quaternary' onClick={deleteInvoice} Icon={Trash} color='gray'>
          Eliminar
        </Button>
      </div>
    </div>
  );
};

export default ResumeInvoiceCard;
